var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyBooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2951 20.1719C10.2555 20.0663 10.163 20.0003 10.044 20.0003H2.11454C1.96916 20.0003 1.85022 19.8815 1.85022 19.7363V8.64699H20.0352V10.1124C20.0352 10.218 20.1013 10.3236 20.207 10.3632C20.6564 10.5348 21.0793 10.7592 21.4757 11.0101C21.6476 11.1157 21.8854 10.9969 21.8854 10.7856V1.95383C21.8854 1.80861 21.7665 1.6898 21.6211 1.6898H17.5903V0.26403C17.5903 0.118814 17.4713 0 17.326 0H16.0044C15.859 0 15.7401 0.118814 15.7401 0.26403V1.6898H6.14537V0.26403C6.14537 0.118814 6.02642 0 5.88105 0H4.55947C4.41409 0 4.29515 0.118814 4.29515 0.26403V1.6898H0.264317C0.118943 1.6898 0 1.80861 0 1.95383V21.5977C0 21.7429 0.118943 21.8617 0.264317 21.8617H10.6916C10.9031 21.8617 11.022 21.6373 10.9163 21.4525C10.6784 21.0432 10.4669 20.6208 10.2951 20.1719ZM2.11454 3.53801H4.29515V4.77895C4.29515 4.92417 4.41409 5.04298 4.55947 5.04298H5.88105C6.02642 5.04298 6.14537 4.92417 6.14537 4.77895V3.53801H15.7533V4.77895C15.7533 4.92417 15.8722 5.04298 16.0176 5.04298H17.3392C17.4846 5.04298 17.6035 4.92417 17.6035 4.77895V3.53801H19.7841C19.9295 3.53801 20.0484 3.65682 20.0484 3.80204V6.81198H1.85022V3.80204C1.85022 3.65682 1.96916 3.53801 2.11454 3.53801Z",
    fill: "url(#paint0_linear_3333_37149)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84143 11.2871H3.51544V13.6106H5.84143V11.2871Z",
    fill: "url(#paint1_linear_3333_37149)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0175 11.2871H7.69147V13.6106H10.0175V11.2871Z",
    fill: "url(#paint2_linear_3333_37149)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84143 16.2378H3.51544V18.5613H5.84143V16.2378Z",
    fill: "url(#paint3_linear_3333_37149)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69147 16.2378V18.5613H9.87208C9.81922 18.2048 9.79279 17.8352 9.79279 17.4655C9.79279 17.0431 9.81922 16.6338 9.89851 16.2378H7.69147Z",
    fill: "url(#paint4_linear_3333_37149)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8855 12.6337C21.3436 12.1321 20.7225 11.7228 20.0353 11.4324C19.5066 11.208 18.9516 11.0495 18.3701 10.9571C18.0529 10.9175 17.7357 10.8911 17.4185 10.8911C16.8238 10.8911 16.2423 10.9703 15.6873 11.1155C15.1586 11.2608 14.6564 11.472 14.1806 11.736C13.3613 12.1981 12.6476 12.8449 12.0925 13.5974C11.2996 14.6799 10.837 16.0133 10.837 17.4523C10.837 18.35 11.0221 19.2081 11.3525 19.9869C11.6432 20.6734 12.0397 21.2939 12.5287 21.8352C13.7313 23.1685 15.4758 24.0134 17.4185 24.0134C21.0529 24.0134 24 21.0695 24 17.4391C24 15.5512 23.1938 13.835 21.8855 12.6337ZM21.8855 18.6668C21.4758 20.1718 20.326 21.3731 18.8591 21.8484C18.4097 21.9936 17.9207 22.0728 17.4185 22.0728C16.9163 22.0728 16.4406 21.9936 15.978 21.8484C14.9736 21.5183 14.1278 20.8582 13.5595 20.0001C13.2688 19.5645 13.0573 19.076 12.9251 18.548C12.8326 18.1915 12.793 17.8351 12.793 17.4523C12.793 17.0298 12.8458 16.6206 12.9516 16.2245C13.3745 14.7064 14.5375 13.505 16.0309 13.043C16.467 12.9109 16.9295 12.8317 17.4053 12.8317C17.7357 12.8317 18.0529 12.8581 18.3568 12.9241C18.9648 13.0562 19.5331 13.2938 20.022 13.637C20.9207 14.2443 21.5815 15.1684 21.8723 16.2377C21.978 16.6206 22.0309 17.0166 22.0309 17.4391C22.0441 17.8747 21.9912 18.284 21.8855 18.6668Z",
    fill: "url(#paint5_linear_3333_37149)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3258 15.2608C20.22 15.1552 20.0614 15.1552 19.9557 15.2608L16.85 18.3632C16.7443 18.4688 16.5857 18.4688 16.48 18.3632L14.8412 16.7262C14.7355 16.6206 14.5769 16.6206 14.4711 16.7262L14.1936 17.0035L13.7178 17.4787C13.6121 17.5843 13.6121 17.7427 13.7178 17.8483L14.1936 18.3236L15.872 20.0002L16.4667 20.5943C16.5725 20.6999 16.7311 20.6999 16.8368 20.5943L20.035 17.4127L21.0658 16.383C21.1716 16.2774 21.1716 16.1189 21.0658 16.0133L20.3258 15.2608Z",
    fill: "url(#paint6_linear_3333_37149)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3333_37149",
    x1: -0.00265565,
    y1: 10.9893,
    x2: 21.8922,
    y2: 10.9893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B62079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3333_37149",
    x1: 3.51516,
    y1: 12.4551,
    x2: 5.84215,
    y2: 12.4551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B62079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3333_37149",
    x1: 7.69119,
    y1: 12.4551,
    x2: 10.0182,
    y2: 12.4551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B62079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3333_37149",
    x1: 3.51516,
    y1: 17.4057,
    x2: 5.84215,
    y2: 17.4057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B62079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3333_37149",
    x1: 7.6912,
    y1: 17.4057,
    x2: 9.8992,
    y2: 17.4057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B62079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3333_37149",
    x1: 10.8354,
    y1: 17.4874,
    x2: 24.0041,
    y2: 17.4874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B62079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3333_37149",
    x1: 13.6376,
    y1: 17.9422,
    x2: 21.1475,
    y2: 17.9422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B62079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B4E4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBooking);
export default __webpack_public_path__ + "static/media/myBooking.ece00ddc5636d49df71e9baf4ca2b242.svg";
export { ForwardRef as ReactComponent };